import { Box } from "@mui/material";

interface NavigationMenuSectionTitleTabletProps {
  children: React.ReactNode;
}

export function NavigationMenuSectionTitleTablet(_props: NavigationMenuSectionTitleTabletProps) {
  return (
    <Box
      sx={(theme) => ({
        height: "1px",
        backgroundColor: theme.palette.navbar?.sectionDivider,
        marginY: 2,
        marginX: 1,
        opacity: 0.6,
      })}
    />
  );
}
